import { useEffect } from "react";
import { useSetAtom } from "jotai";
import {
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signOut as firebaseSignOut,
} from "firebase/auth";

import { auth } from "@/config/firebase";
import { currentUserAtom } from "@/constants/atoms";

function useFirebaseAuth() {
  const setCurrentUser = useSetAtom(currentUserAtom);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);
    });

    return unsubscribe;
  }, [setCurrentUser]);
}

const signIn = async (email: string, password: string) => {
  await signInWithEmailAndPassword(auth, email, password);
};

const signOut = async () => {
  await firebaseSignOut(auth);
};

export { useFirebaseAuth, signIn, signOut };
